<template>
  <el-dialog
    :title="$t('editPrivilegeGroup.editRole')"
    :visible.sync="dialogVisible"
    width="50%"
    :close-on-click-modal="false">
    <el-form 
      ref="form" 
      :model="editPrivilegeGroupInfo" 
      label-width="120px"
      label-position="left">
      <el-alert
        v-if="editPrivilegeGroupInfo.errorInfo"
        :title="editPrivilegeGroupInfo.errorInfo"
        type="error"
        show-icon
        style="margin-bottom: 20px;">
      </el-alert>
      
      <el-form-item 
        :label="$t('editPrivilegeGroup.roleName')"
        prop="name"
        :rules="[
          { required: true, message: $t('editPrivilegeGroup.roleNameRequired'), trigger: 'blur' },
          { min: 2, max: 10, message: $t('editPrivilegeGroup.roleNameLength'), trigger: 'blur' }
        ]">
        <el-input
          v-model="editPrivilegeGroupInfo.name"
          :placeholder="$t('editPrivilegeGroup.roleNamePlaceholder')">
        </el-input>
      </el-form-item>
      
      <el-form-item 
        :label="$t('editPrivilegeGroup.roleDesc')"
        prop="description">
        <el-input
          type="textarea"
          :rows="3"
          v-model="editPrivilegeGroupInfo.description"
          :placeholder="$t('editPrivilegeGroup.roleDescPlaceholder')"
          maxlength="200"
          show-word-limit>
        </el-input>
      </el-form-item>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button 
        type="primary" 
        @click="saveEditPrivilegeGroup"
        :loading="loading">
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updatePrivilegeGroup } from '@/api/privilege/privilegeApi'

export default {
  name: 'EditPrivilegeGroup',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      editPrivilegeGroupInfo: {
        pgId: '',
        name: '',
        description: '',
        errorInfo: ''
      }
    }
  },
  methods: {
    open(pGroup) {
      this.editPrivilegeGroupInfo = {
        pgId: pGroup.pgId,
        name: pGroup.name,
        description: pGroup.description || '',
        errorInfo: ''
      }
      this.dialogVisible = true
    },
    async saveEditPrivilegeGroup() {
      try {
        this.loading = true
        await this.$refs.form.validate()
        
        const res = await updatePrivilegeGroup(this.editPrivilegeGroupInfo)
        if (res.code === 0) {
          this.$message.success(this.$t('editPrivilegeGroup.editSuccess'))
          this.dialogVisible = false
          this.$emit('privilegeGroup_loadPrivilegeGroup')
          this.$emit('roleDiv_loadRole')
        } else {
          this.editPrivilegeGroupInfo.errorInfo = res.msg
        }
      } catch (error) {
        console.error('Failed to update privilege group:', error)
        this.editPrivilegeGroupInfo.errorInfo = error.message
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.el-form-item {
  margin-bottom: 22px;
}
</style>